import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, Link, useHistory } from "react-router-dom";
import { Grid, Image, Dropdown } from 'semantic-ui-react'
import tickCompletedAreYouCelebrity from "../../assets/tickCompletedAreYouCelebrity.gif";
import atar_logo from "../../assets/home/atar_logo.png";
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'

const CelebrityregistScreen = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    return (
        <>
            <div className="container-fluid bg clearall">
                <div className="top">
                    <Grid centered columns={16} >
                        <Grid.Row>
                            <NavLink to=""><Image className="Celeb_logo" src={atar_logo} />
                            </NavLink>
                        </Grid.Row>
                    </Grid>

                </div>
                <div className="celebrity_bg">
                    <Grid centered columns={16} >
                        <h6><img className="submit_img" src={tickCompletedAreYouCelebrity} /></h6>
                        <h6>{t("celebrty3.titel")}</h6>
                        <p>{t("celebrty3.para")} <span> <NavLink to="/faq">{t("celebrty3.faq")}</NavLink> </span>{t("celebrty3.page")} <span><NavLink to="/contactus">{t("celebrty3.connect")}</NavLink> </span> {t("celebrty3.visit")}</p>
                        <div className="clearall destops">
                            <div className="celebbt">
                                <StarButton background={'mainBg'} title={t("celebrty3.btn")} onClickAction={() => history.push("/")} />
                            </div>
                        </div>
                    </Grid>
                </div>
                <div className="mobiles">
                    <StarButton background={'mainBg'} title={t("celebrty3.btn")} onClickAction={() => history.push("/")} />
                </div>
            </div>
        </>
    );
};



export default CelebrityregistScreen;
